import React, { Fragment, useContext } from "react";
import Bg from "../Bg";
import styled, { css, ThemeProvider } from "styled-components";
import { themes } from "../../defaults";
import {
    CSSpsFormGroup,
    getReasonablePaddings,
    ContentBlock,
    CssPaper
} from '../uikit-b2c/uikit-b2c';
import { Svg } from "../uikit-b2c/Svg";
import { InputM } from "../uikit-b2c/InputM";
import { pAmex, getIcon } from '../uikit-b2c/cardIcons';
import Colorer from 'color';
import { ProductContext } from '../../context'

export const CssCardBody = styled.div`
  position: relative;
  z-index: 1;
  padding: 24px;
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  font-size: 1.2em;
`

export const CssCardBody2 = styled.div`
  overflow: hidden;
  position: absolute;
  z-index: 0;
  width: 70%;
  right: 0;
  top: 0px;
  padding: 24px;
  background-color: white;
  border-radius: 8px;
`


export function MethodCard2({
  number = '**** **** **** 8934',
  theme,
  saved,
  icon = 'amex',
}) {

  const valueFromContext = useContext(ProductContext);
  theme= theme || valueFromContext['theme']

  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        {saved && (
          <ContentBlock indentation={0} paddings={"sm"}>
            {/* <CssCardBody
              style={{
                // backgroundColor: Colorer(theme['colorBg']).lighten(0.2).string()
              }}
            > */}


              <CssPaper theme={theme}>

                <div className="">
                  <InputM
                    type="cardNumber"
                    style={{ width: "100%" }}
                    disabled={true}
                    // autofocus={true}
                    // placeholder="0000 0000 0000 0000"
                    value={number}
                    // handle={() => void 0}
                    label="Saved card"
                    extra={<Svg>{getIcon(icon)}</Svg>}
                    monospace
                  />
                </div>

              </CssPaper>



          </ContentBlock>
        )}

        {!saved && (
          <ContentBlock appearance="secondary" indentation={2} paddings={"sm"}>
            <CSSpsFormGroup indentation="xs">
              <ContentBlock indentation={1}>
                <div>
                  <InputM
                    type="cardNumber"
                    style={{ width: "100%" }}
                    autofocus={true}
                    // placeholder="0000 0000 0000 0000"
                    value=""
                    handle={() => void 0}
                    label="Card number"
                    extra={<Svg>{getIcon(icon)}</Svg>}
                    monospace
                  />
                </div>
              </ContentBlock>

              <ContentBlock indentation={"xs"}>
                <CSScardGrid
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr",
                    // gridColumnGap: 24,
                  }}
                >
                  <InputM
                    type="cardExp"
                    value=""
                    handle={() => void 0}
                    label="Month/Year"
                    monospace
                  />
                  <InputM
                    type="cardZip"
                    value=""
                    handle={() => void 0}
                    label="Zip code"
                    monospace
                  />
                  <InputM
                    type="cardCvv"
                    value=""
                    handle={() => void 0}
                    label="CVV code"
                    monospace
                  />
                </CSScardGrid>
              </ContentBlock>
            </CSSpsFormGroup>
          </ContentBlock>
        )}
      </Fragment>
    </ThemeProvider>
  );
}

const CSScardGrid = styled.div`
  ${({ theme }) => css`
    grid-column-gap: ${getReasonablePaddings(theme.paddings)}px;
  `}
`;
